import React from "react";
import "./About.css";
import { Type } from "./Type";
import { BsGithub ,BsFillTelephoneFill,BsTwitter} from "react-icons/bs";
import { Introduction } from "./Introduction";
import { Timeline } from "./Timeline";
import { Techstacks } from "./Techstacks";
import { AiOutlineMail,AiOutlineLinkedin } from "react-icons/ai";
export const About = () => {
  return (
    <>
    
      <div className="about center">
        <h1 data-aos="fade-right" className="mobileHead">
          Hello, I am <span className="about__name">Chandan Kumar</span>
        </h1>
        <Type />
        <p className="about__desc" data-aos="fade-right">
        Dynamic Java Back-end Developer with a proven track record in designing
and implementing robust solutions. Demonstrated expertise in
microservices architecture, system design, and agile methodologies. Adept
at troubleshooting and optimizing databases, proficient in Spring Boot,
Hibernate, and various databases. Committed to delivering high-quality
code and collaborating seamlessly in fast-paced environments.

        </p>
        <div className="about__contact center">
          <a
            href="https://github.com/RavSinghChandan"
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            className="link link--icon"
            style={{fontSize:"34px"}}
          >
           <BsGithub/>
          </a>
          <a
            href="mailto:chandankumar15@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="mail"
            className="link link--icon"
            style={{fontSize:"34px"}}
          >
            <AiOutlineMail />
          </a>
          <a
            href="tel:+916290909518"
            target="_blank"
            rel="noreferrer"
            aria-label="phone"
            className="link link--icon"
            style={{fontSize:"34px"}}
          >
            <BsFillTelephoneFill />
          </a>
          <a
            href="https://www.linkedin.com/in/rav-chandan-kumar-singh-0544b3285/"
            aria-label="linkedin"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
           style={{fontSize:"34px"}}
          >
            <AiOutlineLinkedin />
          </a>
          
        </div>

        <button
          className="btnResume"
          onClick={() => {
            window.open(
              "https://drive.google.com/file/d/1CgNqJHb2cFCY01Hc_WtAT79KIJMkiDLC/view?usp=drivesdk"
            );
          }}
        >
          Resume
        </button>
      </div>
      <Introduction />
      <Timeline />
      <section id="#skills">
        <Techstacks />
      </section>
    </>
  );
};
